<template>
  <div class="more flex-row">
    <div class="line"></div>
    <router-link :to="to" class="more-to flex-row items-center">
      READ MORE
      <v-icon class="icon-more">mdi-arrow-right-circle-outline</v-icon>
    </router-link>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "ReadMore",
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss">
.more {
  .line {
    width: 1px;
    background-color: #979797;
    height: 14px;
    margin: 0 16px;
  }
  .more-to {
    height: 15px;
    font-size: 15px;
    font-weight: 400;
    color: #868686;
    line-height: 15px;
    &:hover {
      color: #0364ff;
      .icon-more {
        color: #0364ff;
      }
    }
    .icon-more {
      font-size: 10px !important;
      margin: 0 9px;
      color: #868686;
    }
  }
}
</style>
